


<button name="{{name}}" class="{{css}} btn btn-lg btn-sm fw-bold rounded-5">
    <!-- <fa-icon [icon]="icon"></fa-icon> -->
  {{ label  }}
</button>

